import React from 'react';
import * as S from './Tooltip.styled';
import { SxProps } from '@mui/material';
export interface ICustomTooltip {
  content: React.ReactNode;
  children: React.ReactNode;
  onMouseOver?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseOut?: (event: React.MouseEvent<HTMLElement>) => void;
  sx?: SxProps;
  showTooltip?: boolean;
}
const CustomTooltip = (props: ICustomTooltip): JSX.Element => {
  const { content, children, onMouseOver, onMouseOut, sx, showTooltip = true } = props;
  const [show, setShow] = React.useState(false);

  const handleMouseOver = (event: React.MouseEvent<HTMLElement>) => {
    setShow(true);

    onMouseOver?.(event);
  };

  const handleMouseOut = (event: React.MouseEvent<HTMLElement>) => {
    setShow(false);

    onMouseOut?.(event);
  };
  if (showTooltip && content) {
    return (
      <S.TooltipWrapper
        className={show ? 'show' : ''}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        sx={sx}>
        {children}
        <S.TooltipBox className='tooltipBox'>
          <S.TooltipText>{content}</S.TooltipText>
        </S.TooltipBox>
      </S.TooltipWrapper>
    );
  }
  return <> {children}</>;
};

export default CustomTooltip;
